import { Injectable, Injector } from '@angular/core';
import { WkUserPreferencesService } from './wk-user-preferences.service';
import { WkCookieService } from './wk-cookie.service';
import { WkEcmUserService } from './wk-ecm-user.service';
import { WkTranslationService } from './wk-translation.service';
import { WkViewUtilService } from './wk-view-util.service';
import { WkStorageService } from './wk-storage.service';
import { WkGroupService } from './wk-group.service';
import { WkLogService } from './wk-log.service';
import { WkThumbnailService } from './wk-thumbnail.service';
import { WkLockService } from './wk-lock.service';

@Injectable({
  providedIn: 'root',
})
export class WkAlfrescoApplicationService {
  private readonly wkUserPreferencesService: WkUserPreferencesService;
  private readonly wkCookieService: WkCookieService;
  private readonly wkEcmUserService: WkEcmUserService;
  private readonly wkTranslationService: WkTranslationService;
  private readonly wkViewUtilService: WkViewUtilService;
  private readonly wkStorageService: WkStorageService;
  private readonly wkGroupService: WkGroupService;
  private readonly wkLogService: WkLogService;
  private readonly wkThumbnailService: WkThumbnailService;
  private readonly wkLockService: WkLockService;

  constructor(injector: Injector) {
    this.wkUserPreferencesService = injector.get<WkUserPreferencesService>(
      WkUserPreferencesService
    );
    this.wkCookieService = injector.get<WkCookieService>(WkCookieService);
    this.wkEcmUserService = injector.get<WkEcmUserService>(WkEcmUserService);
    this.wkTranslationService =
      injector.get<WkTranslationService>(WkTranslationService);
    this.wkViewUtilService = injector.get<WkViewUtilService>(WkViewUtilService);
    this.wkStorageService = injector.get<WkStorageService>(WkStorageService);
    this.wkGroupService = injector.get<WkGroupService>(WkGroupService);
    this.wkLogService = injector.get<WkLogService>(WkLogService);
    this.wkThumbnailService =
      injector.get<WkThumbnailService>(WkThumbnailService);
    this.wkLockService = injector.get<WkLockService>(WkLockService);
  }

  get userPreferences() {
    return this.wkUserPreferencesService;
  }

  get cookie() {
    return this.wkCookieService;
  }

  get ecmUser() {
    return this.wkEcmUserService;
  }

  get translationInstance() {
    return this.wkTranslationService;
  }

  get viewUtilInstance() {
    return this.wkViewUtilService;
  }

  get storageInstance() {
    return this.wkStorageService;
  }

  get groupInstance() {
    return this.wkGroupService;
  }

  get logInstance() {
    return this.wkLogService;
  }

  get thumbnailInstance() {
    return this.wkThumbnailService;
  }

  get lockInstance() {
    return this.wkLockService;
  }
}
